/**
 * walletEvents.js — Event bus pour la synchronisation cross-components.
 *
 * Deux événements :
 *   • wallet:changed  — déclenché par trade / dépôt / retrait
 *   • market:changed  — déclenché par trade (les prix LMSR ont bougé)
 *
 * Utilisation :
 *   import { dispatchWalletChange, dispatchMarketChange,
 *            onWalletChange, onMarketChange } from "./walletEvents";
 *
 *   // Après un trade :
 *   dispatchWalletChange();
 *   dispatchMarketChange({ marketId: market.id });
 *
 *   // Dans Navbar / WalletPage :
 *   useEffect(() => onWalletChange(() => reloadBalance()), []);
 *
 *   // Dans MarketDetail / MarketList :
 *   useEffect(() => onMarketChange(({ marketId }) => {
 *     if (marketId === currentMarket.id) reload();
 *   }), []);
 */

const WALLET_EVENT = "evenmt:wallet-changed";
const MARKET_EVENT = "evenmt:market-changed";

/* ── Wallet ──────────────────────────────────────────────────────────── */

export function dispatchWalletChange(payload = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(WALLET_EVENT, { detail: payload }));
}

export function onWalletChange(callback) {
  if (typeof window === "undefined") return () => {};
  const handler = (e) => callback(e.detail);
  window.addEventListener(WALLET_EVENT, handler);
  return () => window.removeEventListener(WALLET_EVENT, handler);
}

/* ── Market (prix LMSR ont changé) ───────────────────────────────────── */

export function dispatchMarketChange(payload = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(MARKET_EVENT, { detail: payload }));
}

export function onMarketChange(callback) {
  if (typeof window === "undefined") return () => {};
  const handler = (e) => callback(e.detail);
  window.addEventListener(MARKET_EVENT, handler);
  return () => window.removeEventListener(MARKET_EVENT, handler);
}
